import { Paper, Title } from '@mantine/core';
// components
import type { TSessionByASR } from '@newo/api/gateway';
import StatItem from '@/pages/Report/components/StatItem';
import ASRAreaChart from '@/pages/Report/components/ASR/components/ASRAreaChart';
import EmptyView from '@/pages/Report/components/EmptyView';
// utils
import { hints } from '@/pages/Report/Report.data';

interface ASRProps {
    totalASR: number;
    data: TSessionByASR[];
}

const ASR = ({ data, totalASR }: ASRProps) => {
    return (
        <Paper
            className="space-y-4 p-4 lg:p-6 border-solid border border-gray-3 print:p-0"
            radius="md"
        >
            <Title className="mb-4" order={3} size="h3">
                Additional Secured Revenue (ASR)
            </Title>
            <div className="flex flex-col md:flex-row md:justify-between gap-4">
                <div className="max-w-lg text-xs text-gray-6 leading-relaxed">
                    The term Additional Secured Revenue (ASR) refers to the
                    revenue your business earned exclusively thanks to Newo AI
                    Employee. To understand how ASR is calculated, refer to the
                    table below.
                </div>
                <StatItem
                    hint={hints.asr}
                    prefix="$"
                    title="Additional Secured Revenue (ASR)"
                    value={totalASR}
                    valueClassName="text-green-5"
                />
            </div>
            {data.length === 0 ? <EmptyView className="h-96" /> : undefined}
            {data.length > 0 ? <ASRAreaChart data={data} /> : undefined}
        </Paper>
    );
};

export default ASR;
